import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import SettingsModal from '../components/SettingsModal';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import useMutation from '../../../../../modules/react/hooks/useMutation';

const GET_BLOG_DATA = gql`
query GetCurrentSiteBlogData {
  currentSite {
    id
    ...CurrentSiteBlogDataSettingsModal
  }
}

${SettingsModal.fragments.currentSite}
`;

const UPDATE_SETTINGS = gql`
  mutation UpdateBlogSettings($input: SiteBlogSettingsInput!) {
    currentSiteBlogSettingsUpdate(input: $input) {
      currentSite {
        id
        ...CurrentSiteBlogDataSettingsModal
      }
    }
  }

  ${SettingsModal.fragments.currentSite}
`;

const propTypes = {
  hideSettingsModal: PropTypes.func.isRequired,
};

const defaultProps = {};

const SettingsModalContainer = ({ hideSettingsModal, ...rest }) => {
  const { data, loading } = useQuery(GET_BLOG_DATA);
  const [
    updateSettings,
  ] = useMutation(UPDATE_SETTINGS, { refetchQueries: ['GetCurrentSiteBlogData'] });

  if (!data) {
    return null;
  }

  const onSubmit = (input) => {
    hideSettingsModal();
    updateSettings({ variables: { input } });
  };

  return (
    <SettingsModal
      {...rest}
      hideSettingsModal={hideSettingsModal}
      loading={loading}
      site={data.currentSite}
      onSubmit={onSubmit}
    />
  );
};

SettingsModalContainer.propTypes = propTypes;
SettingsModalContainer.defaultProps = defaultProps;

SettingsModalContainer.fragments = {};

export default SettingsModalContainer;
